module.exports = __webpack_public_path__ + "static/media/31-3.307476cd.mp3";